import { render, staticRenderFns } from "./userAmount.vue?vue&type=template&id=551580ad&scoped=true&"
import script from "./userAmount.vue?vue&type=script&lang=js&"
export * from "./userAmount.vue?vue&type=script&lang=js&"
import style0 from "./userAmount.vue?vue&type=style&index=0&id=551580ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551580ad",
  null
  
)

export default component.exports